
import './home.css';
import { HomeBanner } from './HomeBanner';
import Collections from '../collection/Collections';


export const HomeIndex = () => {
  return (
    <section className=' h-screen  md:mx-8 '>
        <HomeBanner/>
        <Collections/>

    </section>
  )
}


 